import _createForOfIteratorHelper from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _classCallCheck from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "D:/a/1/s/fed/node_modules/@babel/runtime/helpers/esm/createClass.js";
import { ControlCard } from "./models/index.js";
import c from "../common/event-logger.js";
import H from "../models/request-result.js";
import { logger as E, EventTypes as m } from "../../shared-lib/index.js";
import { STORAGE_KEYS as s } from "../managers/storage-manager.js";
var M = /*#__PURE__*/function () {
  function M(t) {
    _classCallCheck(this, M);
    this.j = t, this.j = t;
  }
  _createClass(M, [{
    key: "logClick",
    value: function logClick(t) {
      var n = new H();
      if (t.$t(), null == t.url || "" === t.url) return E.info("Card ".concat(t.id, " has no url. Not logging click to Braze servers.")), n;
      if (t.id && this.j) {
        var _n = this.j.lt(s.ct.Et) || {};
        _n[t.id] = !0, this.j.ft(s.ct.Et, _n);
      }
      var r = this.Gt([t]);
      if (null == r) return n;
      var i = m.Ht;
      return c.rt(i, r);
    }
  }, {
    key: "Jt",
    value: function Jt(t) {
      var n = new H();
      if (!t.Kt()) return E.info("Card ".concat(t.id, " refused this dismissal. Ignoring analytics event.")), n;
      if (t.id && this.j) {
        var _n2 = this.j.lt(s.ct.Lt) || {};
        _n2[t.id] = !0, this.j.ft(s.ct.Lt, _n2);
      }
      var r = this.Gt([t]);
      return null == r ? n : c.rt(m.Mt, r);
    }
  }, {
    key: "Ot",
    value: function Ot(t) {
      var n = new H(!0),
        r = [],
        i = [];
      var o = {};
      this.j && (o = this.j.lt(s.ct.Pt) || {});
      var _iterator = _createForOfIteratorHelper(t),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _s2 = _step.value;
          _s2.Qt() ? (_s2 instanceof ControlCard ? i.push(_s2) : r.push(_s2), _s2.id && (o[_s2.id] = !0)) : E.info("Card ".concat(_s2.id, " logged an impression too recently. Ignoring analytics event."));
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      var e = this.Gt(r),
        l = this.Gt(i);
      if (null == e && null == l) return n.W = !1, n;
      if (this.j && this.j.ft(s.ct.Pt, o), null != e) {
        var _t = m.Ut,
          _s = c.rt(_t, e);
        n.Vt(_s);
      }
      if (null != l) {
        var _t2 = c.rt(m.Wt, l);
        n.Vt(_t2);
      }
      return n;
    }
  }, {
    key: "Gt",
    value: function Gt(t) {
      var s,
        n = null;
      for (var r = 0; r < t.length; r++) s = t[r].id, null != s && "" !== s && (n = n || {}, n.ids = n.ids || [], n.ids.push(s));
      return n;
    }
  }]);
  return M;
}();
export { M as default };